/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { LasgroNotification_triggerCollection } from '../models/lasgro-notification-_trigger-collection';
@Injectable({
  providedIn: 'root',
})
class NotificationTriggerService extends __BaseService {
  static readonly notificationTriggerListPath = '/notifications/triggers';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * list notification_trigger
   *
   * List all of the notification triggers
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  notificationTriggerListResponse(): __Observable<__StrictHttpResponse<LasgroNotification_triggerCollection>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/notifications/triggers`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<LasgroNotification_triggerCollection>;
      })
    );
  }
  /**
   * list notification_trigger
   *
   * List all of the notification triggers
   *
   * Required security scopes:
   *   * `api:access`
   * @return OK
   */
  notificationTriggerList(): __Observable<LasgroNotification_triggerCollection> {
    return this.notificationTriggerListResponse().pipe(
      __map(_r => _r.body as LasgroNotification_triggerCollection)
    );
  }
}

module NotificationTriggerService {
}

export { NotificationTriggerService }
